import React, { Component, createRef, Fragment } from "react";
import {
  Hero,
  Title,
  TechniqueTitle,
  ClientTag,
  CaseWrapper,
  BackButton,
  BackArrow
} from "../styles/Case.styles";

import Reveal from 'react-reveal/Reveal';
import { withRouter } from "react-router";
import Footer from '../components/Footer';
import { Efectr, Efectr1, Efectr2  } from "../styles/effect.styles";

export const ScrollTop = ({ children, location }) => {
  React.useEffect(() => window.scrollTo(0, 0), [location])
  return children
}

class Case extends Component {
  constructor(props) {
    super(props);
    this.introRef = createRef();

    this.state = {
          toBack: false,
          introTop: 0,
          hasBackground: false,
          animateCase: ""
        };
      }
    
      componentDidUpdate() {
        if (this.state.toBack) {
          setTimeout(() => {
            this.props.setNavBackground(false);
            this.props.history.push("/blog");
          }, 400);
        }
        if (this.state.animateCase) {
          setTimeout(() => {
            this.props.setNavBackground(false);
    
            this.props.history.push(this.state.animateCase);
            window.scrollTo(0, 0);
          }, 400);
        }
      }
    
    
      render() {
        return (
          <Fragment>
          <Efectr/>
          <Efectr1/>
          <Efectr2/>
          <ScrollTop>
            <CaseWrapper>
              <Reveal effect="fadeIn">
                <Hero className='mainhero' style={{ backgroundImage: "url('./img/news/WOW9LRG.png')" }}>
                    <div className='herocaption'>
                      <BackButton className='backdetail'
                        onClick={() => this.setState({ toBack: true, hasBackground: false })}
                        toBack={this.state.toBack}
                        hasBackground={this.state.hasBackground}>
                        <BackArrow src="./img/back.png" alt="Back to blog" />
                        <span>Back </span>
                      </BackButton>
                      <div className='container'>
                        <div className='row'>
                          <div className='col-md-12 pl-md-0'>
                            <ClientTag className='date'>September 18, 2024</ClientTag>
                            <Title>Cold & Flu Season</Title>
                            <TechniqueTitle>
                            Let's protect your body against the sickness!
                            </TechniqueTitle>
                          </div>
                        </div>
                      </div>
                    </div>
                </Hero>
              </Reveal>
    
              <section className='container' id='detailproject'>
                <div className='row'>
                  <div className='col-md-12'>
                    <p className='content'>Back-to-school season is here, and even if you are not hitting the books, someone’s kids are! With that, germs, bacteria, and the inevitable colds and flu start circulating. But do not worry - there are plenty of natural ways to support your body & stay healthy!</p>
                    <p className='content'> One of the best things about naturopathic medicine is its focus on preventing illness and promoting wellness through simple, everyday habits. A strong, resilient body is your best defence, and the stronger your immune system, the better equipped you are to fend off those pathogens!</p>
                     <p className='content'> To help prevent colds and flu, focus on healthy lifestyle habits like getting at least 30 minutes of moderate activity each day, aiming for 7-8 house of restful sleep, staying hydrated, and feeling your body with optimal nutrition. A little prevent goes a long way!</p>

                  
                    <h3 className='my-5'>Natural Remedies for Colds & Flus</h3>
                    <div>
                      <p className='content'>1. Vitamin A: important for the health of the skin & mucus membranes (the 1st line of defence against pathogens!) </p>
                      <p className='content'>2. Vitamin C: essential for various immune cells and acts as an antioxidant reducing inflammation and protecting cells against free radical damage during infection. </p>
                      <p className='content'>3. Vitamin D: Enhances the pathogen-fighting effects of white blood cells. Additionally regulates the immune response to prevent inflammation and allergic reactions. </p>
                      <p className='content'>4. Zinc & Copper: important for the production of immune cells and for decreasing inflammation within the body. Both are needed to maintain balance of one another.  </p>
                      <p className='content'>5. Rosemary & Oregano: provides potent antioxidant, anti-inflammatory, & anti-microbial properties. </p>
                      <p className='content'> 6. Garlic: used traditionally for medicinal properties to boost the immune system through helping fight off infections and anti-inflammatory support.  </p>
                      <p className='content'> 7. Green Tea: particularly the compound ECGC within green tea has been shown to decrease inflammation and has antimicrobial and immune modulating properties.  </p>
                      <p className='content'> 8. Expert help: Speak with your Naturopathic Doctor to learn more about which supplements and doses are right for you! </p>
                    </div>
                  </div>  

                  <div className='col-md-12'></div>
                  <div className='share'>
                    <span className='heading'>
                    Share this blog post :
                    </span>
                    <span className='content'> 
                    <a href="https://www.facebook.com/sharer/sharer.php?u=drmichellemaliknd.com/WOW9" target="_blank" rel="noopener noreferrer">  
                      <i className="fa fa-facebook-f"></i>
                      </a>  
                    </span>
                    <span className='content'> 
                    <a href="https://www.instagram.com/dr.michellemalik.nd" target="_blank" rel="noopener noreferrer">   
                      <i className="fa  fa-instagram"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </section>

            </CaseWrapper>

                      </ScrollTop>
                
                      <Footer />
                
                      </Fragment>
                    );
                  }
                }
                
                export default withRouter(Case);